import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
SwiperCore.use([Navigation]);
var Container = styled.div.withConfig({
  displayName: "InfoSlider__Container",
  componentId: "sc-6924tl-0"
})([".mySwiper{margin-top:28px;padding:0 10px 0 10px;--swiper-theme-color:black !important;--swiper-navigation-size:25px;.menu-img{height:200px;width:100%;}.menu-info{margin-top:0;line-height:20px;}.local-slider-div{}.local-floor-div{margin-right:3vw;margin-left:3vw;}.detail-img{width:100%;min-width:300px;border:0 none;}.floor-content{margin-top:0;line-height:20px;h4{font-size:13px;}p{font-size:13px;}}}@media (min-width:786px){.local-floor-div{display:flex;}.local-slider-div{padding:0 2vw 0 2vw;display:flex;align-items:center;}.floor-content{padding-left:28px;}.menu-info{margin-top:0;padding-left:27px;font-size:15px;line-height:24px;}.menu-img{max-width:353px;width:45% !important;}}"]);

var InfoSlider = function InfoSlider(_ref) {
  var floors = _ref.floors,
      menus = _ref.menus;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Swiper, {
      navigation: true,
      spaceBetween: 30,
      loop: true,
      className: "mySwiper",
      children: [floors && floors.map(function (floor) {
        return /*#__PURE__*/_jsx(SwiperSlide, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "local-floor-div",
            children: [/*#__PURE__*/_jsx("span", {
              className: "fl-img",
              style: {
                flex: 1
              },
              children: /*#__PURE__*/_jsx("img", {
                src: floor.image,
                alt: "",
                className: "detail-img"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "floor-content",
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs("h4", {
                  children: [floor.floor, "F ", floor.title]
                }), /*#__PURE__*/_jsx("p", {
                  children: floor.description
                })]
              })
            })]
          })
        }, floor.id);
      }), menus && menus.map(function (menu) {
        return /*#__PURE__*/_jsx(SwiperSlide, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "local-slider-div",
            children: [/*#__PURE__*/_jsx("img", {
              src: menu.image,
              alt: "",
              className: "menu-img"
            }), /*#__PURE__*/_jsxs("div", {
              className: "menu-info",
              children: [/*#__PURE__*/_jsx("strong", {
                children: menu.name
              }), /*#__PURE__*/_jsx("p", {
                children: menu.description
              })]
            })]
          })
        }, menu.name);
      })]
    })
  });
};

export default InfoSlider;